import { ApolloProvider } from '@apollo/client';
import React from 'react';
import ReactDOM from 'react-dom';
import ShopByColor from '../../_shared/ui-components/ShopByColor';
import defaultClient from '../../_shared/apolloClient';

const targets = Array.from(document.querySelectorAll('[react-render-target="ShopByColor"]'));

targets.forEach((element) => {
  const tags = element.dataset.tags?.split(',');
  const colorTag = tags?.find((tag) => tag.includes('Color:'));
  if (tags && tags.length > 0 && colorTag) {
    ReactDOM.render(
      <ApolloProvider client={defaultClient}>
        <ShopByColor tags={tags} />
      </ApolloProvider>,
      element
    );
  }
});
